import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { SimplebarAngularComponent, SimplebarAngularModule } from 'simplebar-angular';
import { Category } from 'src/app/core/backend/pn/models';

@Component({
  selector: 'mg-aside-wrapper',
  standalone: true,
  imports: [CommonModule,SimplebarAngularModule],
  templateUrl: './aside-wrapper.component.html',
  styleUrls: ['./aside-wrapper.component.scss']
})
export class AsideWrapperComponent {

  open = false;
  toggle(){
    this.open = !this.open;
  }


  activatedCat: Category | undefined;
  @Input() 
  public set setActiveCat(v : Category) {
    this.activatedCat = v;
    this.scrollToActivatedCat();
  }


  @ViewChild('simplebar') simpleBar: SimplebarAngularComponent;
  scrollToActivatedCat() {
    if (this.activatedCat?.id) {
      setTimeout(() => {
        const currentPosition = this.simpleBar.elRef?.nativeElement?.getElementsByClassName("active")[0]['offsetTop'];
        if (this.simpleBar.SimpleBar !== null && currentPosition) {
          this.simpleBar.SimpleBar.getScrollElement().scrollTop = currentPosition;
        }
      }, 10);
    }
  }
}
